export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/WI-a2b9d4eab21e329e8ce5754859c15dc7.PNG";